export enum Priority {
  Primary = 0,
  Secondary = 1
}
